var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechProfessional(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "dna_1_"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "investment"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "company"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "square-meter"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "bios-generics"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "professional"
  }, /*#__PURE__*/React.createElement("path", {
    id: "neutral_22_",
    className: "st0",
    d: "M227.7,36v18c-19.6-11.4-42.4-18-66.8-18C87.2,36,27.4,95.8,27.4,169.5v311.6h200.3v-44.5 h66.8c0,0,0-17.9,0-44.5h178V36H227.7z M272.3,414.3h-44.5h-22.3v22.3v22.3H49.7V169.5c0-61.4,49.9-111.3,111.3-111.3 c61.4,0,111.3,49.9,111.3,111.3v11.1H250c-9.8,0-17,3.3-22.3,8c-6.7-5.6-15.3-8-22.2-8H161c-18.2,0-27.8,11.1-31.5,22.3H94.2 c-24.5,0-33.4,20-33.4,33.4v22.3c0,6.2,5,11.1,11.1,11.1c6.2,0,11.1-5,11.1-11.1v-22.1c0.1-5.1,2.2-11.3,11.1-11.3h33.4v11.1 c0,24.5,20,33.4,33.4,33.4h44.5c9.8,0,17-3.3,22.3-8c6.7,5.6,15.3,8,22.2,8h22.3V414.3z M216.6,214v22.1 c-0.1,5.1-2.2,11.3-11.1,11.3h-44.4c-5.1-0.1-11.3-2.2-11.3-11.1v-22.1c0.1-5.1,2.2-11.3,11.1-11.3h44.4 C210.5,203,216.6,205.1,216.6,214z M283.4,236.2c-0.1,5.1-2.2,11.3-11.1,11.3h-22.1c-5.1-0.1-11.3-2.2-11.3-11.1v-22.1 c0.1-5.1,2.2-11.3,11.1-11.3h22.1c5.1,0.1,11.3,2.2,11.3,11.1V236.2z M450.3,369.8H294.5c0-7.1,0-14.6,0-22.3H339 c6.2,0,11.1-5,11.1-11.1s-5-11.1-11.1-11.1h-44.5c0-11,0-22.2,0-33.4h22.3c6.2,0,11.1-5,11.1-11.1c0-6.2-5-11.1-11.1-11.1h-22.3 c0-2.7,0-5.3,0-8c7.8-7,11.1-17.4,11.1-25.4h11.1c6.2,0,11.1-5,11.1-11.1s-5-11.1-11.1-11.1h-11.1c0-9.8-3.3-17-8-22.3H428 c6.2,0,11.1-5,11.1-11.1s-5-11.1-11.1-11.1H294.5c0-7.6-0.8-15-2-22.3H428c6.2,0,11.1-5,11.1-11.1s-5-11.1-11.1-11.1H286.8 c-2.8-7.8-6.2-15.2-10.3-22.3H428c6.2,0,11.1-5,11.1-11.1s-5-11.1-11.1-11.1H272.3c-3.4,0-6.3,1.6-8.3,4c-4.2-5.1-9-9.8-13.9-14.3 v-12h200.3V369.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "color_16_",
    className: "st1",
    d: "M421.5,258.5l3.3-3.3l19-19h-26.9v-26.9l-19,19l-3.3,3.3l-3.3-3.3l-19-19v26.9h-26.9l19,19 l3.3,3.3l-3.3,3.3l-19,19h21.3V361l27.8-27.8l27.8,27.8v-80.2h21.3l-19-19L421.5,258.5z M411.4,334.1l-16.7-16.7L378,334.1v-32 l13.4-13.4l3.3-3.3l3.3,3.3l13.4,13.4V334.1z M416.9,269.7h-11.1v11.1l-11.1-11.1l-11.1,11.1v-11.1h-11.1l11.1-11.1l-11.1-11.1 h11.1v-11.1l11.1,11.1l11.1-11.1v11.1h11.1l-11.1,11.1L416.9,269.7z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "capacity"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "award"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "pills"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  })));
}

export default SvgAlvotechProfessional;